var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-priceinfo" }, [
    _vm._v(
      "\n  Totalt: " + _vm._s(_vm.totalPrice.toLocaleString("nb-NO")) + ",–\n  "
    ),
    _vm.$store.state.entities.calculatorsettings.hasCommunalPrice === true
      ? _c("span", [
          _vm._v(
            "\n      |  " +
              _vm._s(_vm.monthlyPrice.toLocaleString("nb-NO")) +
              ",– per måned\n  "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }